// extracted by mini-css-extract-plugin
export var bounce = "_lh-1";
export var generatingText = "_lh-6";
export var lightning = "_lh-4";
export var popup = "_lh-5";
export var progressBar = "_lh-7";
export var progressFill = "_lh-8";
export var progressShimmer = "_lh-9";
export var progressText = "_lh-a";
export var shimmer = "_lh-3";
export var uploadIcon = "_lh-0";
export var uploadingText = "_lh-2";